<template>
  <div>
    <a-form :form="form" v-bind="formLayout">
      <a-row :gutter="[16,16]">
        <a-col :span="12">
          <a-form-item label="条形码">
            <a-input disabled v-decorator="['barcode', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="最小值" >
            <a-input-number :precision="2" v-decorator="['min_price', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="最大值" >
            <a-input-number :precision="2" v-decorator="['max_price', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="比例" >
            <a-input-number :min="0" v-decorator="['consumption_tax_rate', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" />
          </a-form-item>
        </a-col>
        <a-col span="24" style="text-align: center">
          <a-button style="margin-right: 40px;" type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
          <a-button style="margin-left: 40px;" @click="handleGoBack">返回</a-button>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import pick from 'lodash.pick'
import { consumption_tax_level_update } from '@/api/c_wms_consumption_tax_level'
// 表单字段
const fields = ['id', 'barcode', 'min_price', 'max_price', 'consumption_tax_rate']
export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    return {
      formLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 9 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 13 }
        }
      },
      form: this.$form.createForm(this),
      id: 0
    }
  },
  mounted () {
    this.$nextTick(() => {
      fields.forEach(v => this.form.getFieldDecorator(v))
      this.loadEditInfo(this.record)
    })
  },
  methods: {
    handleGoBack () {
      this.$emit('onGoBack')
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        if (err) {
          console.log(values, err)
          return
        }
        consumption_tax_level_update(values, this.id)
          .then((res) => {
            this.handleGoBack()
    })
      })
    },
    loadEditInfo (data) {
      const { form } = this
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        console.log(this.record)
        console.log(data)
        const formData = pick(data, fields)
        this.id = formData.id
        formData.min_price = (formData.min_price / 100).toFixed(2)
        formData.max_price = (formData.max_price / 100).toFixed(2)
        form.setFieldsValue(formData)
      })
    }
  }
}
</script>
